import React, { useEffect, useState } from "react";
import ContentWrapper from "../../template/Layout/ContentWrapper";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { withNamespaces } from "react-i18next";
import { Icon } from "semantic-ui-react";
import { Col, Row, Card, CardBody, Button } from "reactstrap";
import ImageUpload from "../Components/ImageUpload";
import { useCallback } from "react";
import { Services } from "../../../repositories/clients/Services";
import Axios from "axios";
import { connect } from "react-redux";
import { Autocomplete, TextField } from "@mui/material";
import Loader from "../../Global/Loader";
import xls from "../../../resources/excel.svg"
import createModal from "../Components/ModalV2";

const filesAccepted = [
  "application/vnd.ms-excel.sheet.macroEnabled.12",
  "application/vnd.ms-excel.sheet.macroenabled.12",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ".xlsm",
  "xlsm",
  ".xlsx",
  "xlsx",
];

const maxSizeFile = "2MB";

function LoadPO(params) {
  const [entities] = useState(params.clients);
  const [file, setFile] = useState([]);
  const [selectedValue, setSelectedValue] = useState(null);
  const [validating, setValidating] = useState(false);
  const [hiddenLoadButton, setHiddenLoadButton] = useState(true);
  const [catalogEntities, setCatalogEntities] = useState([]);
  const [loadPos, setLoadPos] = useState([]);
  const [codeEP, setCodeEP] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [loader, setLoader] = useState(true);
  const [modalAlert, setModalAlert] = useState(false);
  const [uploadDocPo, setUploadDocPo] = useState(false);
  const [modalType, setModalType] = useState("success");
  const [modalMessage, setModalMessage] = useState("");

  function callFile(dataFile) {
    // if (dataFile?.fileExtension.indexOf(filesAccepted) > -1 && dataFile?.fileSize <= maxSizeFile) {
    if (dataFile) {
      setFile(dataFile.file);
    } else {
      setFile([]);
      setHiddenLoadButton(true);
      setValidating(false);
    }
  }

  async function validateData(data) {
    try {
      let url = `${Services.PURCHASE_ORDER.path}purchaseOrder/validateData`;
      let res = await Axios.post(url, data);
      if (res.data.valid) {
        setModalAlert(true)
        setModalMessage(params.t("po_management_upload_doc_valid"));
        setModalType('success')
        setHiddenLoadButton(false);
        setLoadPos(res.data.data);
      } else {
        setModalAlert(true)
        setModalMessage(params.t("po_management_upload_doc_please_check"));
        setModalType('error')
        setValidating(false);
      }
    } catch (error) {
      console.log("🚀 ~ validateData ~ error:", error);
    }
  }

  const transformXLS = useCallback(async () => {
    setValidating(true);
    const formData = new FormData();
    if (file) {
      formData.append("file", file);
      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${process.env.REACT_APP_XML_TO_JSON}api/v1/excel/getdata`,
        headers: new Headers(),
        data: formData,
      };

      Axios.request(config)
        .then((response) => {
          const nameTab = Object.keys(response.data.data[0].result)[0];
          validateData(response.data.data[0].result[nameTab]);
        })
        .catch((error) => {
          console.log("🚀 ~ validateDoc ~ error:", error);
        });
    }
  }, [file]);

  const catEntities = useCallback(async () => {
    let body = { entities: entities };

    try {
      let url = `${Services.PURCHASE_ORDER.path}purchaseOrder/entities`;
      let res = await Axios.post(url, body);
      setCatalogEntities(res.data.data);
    } catch (error) {
      console.log("🚀 ~ catEntities ~ error:", error.message);
    }
  }, []);

  const uploadPos = useCallback(async () => {
    setValidating(!validating);
    setLoader(!loader);

    for (let item in loadPos) {
      loadPos[item].PO.POCreationDate = new Date().toISOString();
    }
    let body = { data: [...loadPos], customerCode: codeEP };
    try {
      let config = {
        method: "post",
        url: `${Services.PROCESS_JOBS.path}api/v1/process/po`,
        headers: {
          apikey: "19c401a6-5407-4eaf-92a2-344ea695cd8e",
          "Content-Type": "application/json",
        },
        data: body,
        timeout: 120000, // 2 minutos de tiempo de espera en milisegundos
      };

      Axios.request(config)
        .then((response) => {
          setLoader(true);
          {
            if (response.data.poExist.length !== 0) {
              setUploadDocPo(true)
              setModalMessage(
                <>
                  {/* <p>{params.t("po_management_upload_loaded_successfully")}</p> */}
                  <p>{params.t("po_management_upload_no_loaded")}</p>
                  <p>{response.data.poExist.join(", ")}</p>
                </>
              );
              setModalType('success')
              // setAction(() => () => params.history.push("/po-management"));
            } else {
              setUploadDocPo(true)
              setModalMessage(params.t("po_management_upload_loaded_successfully"));
              setModalType('success')
            }
          }
        })
        .catch((error) => {
          setValidating(true);
          setLoader(true);
          if (error.response) {
            let message =
              error.response.data.data == "All POs already exist in the DB"
                ? params.t("po_management_upload_doc_po_exist")
                : error.response.data.data.replace("PO() PO validate :", "");

            setModalAlert(true)
            setModalMessage(`Error: ${message}`);
            setModalType('error')
          } else if (error.request) {
            // La petición fue realizada pero no se recibió respuesta

            setModalAlert(true)
            setModalMessage(`Error en la petición: ${error.request}`);
            setModalType('error')
          } else {
            // Algo ocurrió al configurar la petición
            console.error("Error:", error.message);
          }
        });
    } catch (error) {
      setValidating(true);
      console.log("🚀 ~ uploadPos ~ error:", error);
    }
  }, [loadPos, codeEP]);

  const handleChange = (data) => {
    setCodeEP(data ? data.CodeEP : null);
    setSelectedValue(data ? data.id : null);
  };

  useEffect(() => {
    catEntities();
  }, []);

  return (
    <ContentWrapper>
      <Loader hidden={loader} />
      <div className="content-heading">
        <span className="icon-po-management icon-header" />
        {params.t("po_management_upload")}
        <div className="euro-return-tittle">
          <Icon.Group size="large">
            <Icon
              name="angle left"
              className="_btnBack"
              size="big"
              onClick={() => params.history.push("/po-management")}
            />
          </Icon.Group>
          <span className="label-back" onClick={() => params.history.push("/po-management")}>
            {params.t("back")}
          </span>
        </div>
      </div>
      <Card className="myCard">
        <CardBody>
          <Row>
            <Col xs={12} sm={12} md={7} lg={8}>
              <Col xs={12} sm={12} md={11} lg={9} className="mr-auto ml-auto">
                <div className="d-flex justify-content-end ml-auto mt-5 mb-5">
                  <a
                    className="link-euro"
                    href={process.env.REACT_APP_FILE_MACRO}
                  >
                    <span className="download-template">
                      <img src={xls} title={params.t("download_excel")} style={{ width: '32px', cursor: 'pointer' }} />
                      {params.t("po_management_download_template")}
                    </span>
                  </a>
                </div>
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-11 align-items-center mr-auto ml-auto pt-4 mb-5">
                  <span className="label-euro bold mr-2">
                    {params.t("po_management_select_company")}
                  </span>
                  <Autocomplete
                    options={catalogEntities}
                    getOptionLabel={(option) => option.label}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    renderInput={(params) => (
                      <TextField {...params} variant="standard" />
                    )}
                    inputValue={inputValue}
                    onInputChange={(event, newInputValue) =>
                      setInputValue(newInputValue)
                    }
                    filterOptions={(options, { inputValue }) => {
                      if (inputValue.length < 3) {
                        return options;
                      }
                      return options.filter((option) =>
                        option.label
                          .toLowerCase()
                          .includes(inputValue.toLowerCase())
                      );
                    }}
                    // options={catalogs && catalogs[item.id] ? catalogs[item.id] : []}
                    onChange={(evt, data) => {
                      handleChange(data);
                    }}
                    // onChange={handleChange}
                    renderOption={(props, option) => (
                      <li {...props} key={option.id || option.CodeEP}>
                        {option.label}
                      </li>
                    )}
                    ListboxProps={{
                      sx: {
                        fontSize: 12,
                        color: "#000",
                      },
                      style: {
                        maxHeight: 160, // Aproximadamente 6 opciones visibles
                      },
                    }}
                    sx={{
                      "& .MuiAutocomplete-input, & .MuiInputLabel-root": {
                        fontSize: 12,
                        color: "#000",
                      },
                    }}
                    clearOnEscape
                    noOptionsText={params.t("po_management_select_no_options")}
                  />
                </div>
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-11 align-items-center mr-auto ml-auto pb-5">
                  <span className="label-euro bold mr-2">
                    {params.t("po_management_upload_file")}
                  </span>
                  <ImageUpload
                    callFile={callFile}
                    lng={params.t}
                    filesAccepted={filesAccepted}
                    maxSizeFile={maxSizeFile}
                    fileValidateTypeLabelExpectedTypes={params.t("po_management_upload_file_only_xls")}
                    labelMaxFileSizeExceeded={params.t("po_management_upload_file_is_too_large")}
                    labelMaxFileSize={params.t("po_management_upload_file_maximun_file_size")}
                  />
                </div>
                <div className="d-flex justify-content-center">
                  <Button
                    color="primary"
                    onClick={transformXLS}
                    hidden={
                      file.length !== 0 && selectedValue && hiddenLoadButton
                        ? false
                        : true
                    }
                    disabled={validating}
                  >
                    {validating
                      ? params.t("po_management_upload_doc_validating")
                      : params.t("po_management_upload_file_validate_button")}
                  </Button>
                  <Button
                    color="primary"
                    onClick={uploadPos}
                    hidden={
                      hiddenLoadButton || !(file.length !== 0 && selectedValue)
                    }
                    disabled={!validating}
                  >
                    {params.t("po_management_upload_doc_upload")}
                  </Button>
                </div>
              </Col>
            </Col>
            <Col xs={12} sm={12} md={5} lg={4} className="left-col-border">
              <div className="d-flex justify-content-center">
                <span className="download-template">
                  {params.t("po_management_upload_instructions")}
                </span>
              </div>
              <div className="pt-4 pb-2">
                <p className="label-euro bold">
                  {params.t("po_management_upload_instructions_1")}
                </p>
                <p className="cardNameResumen">
                  {params
                    .t("po_management_upload_instructions_1_description")
                    .replaceAll("*", '"')}
                </p>
                <p className="cardNameResumen">
                  {params
                    .t("po_management_upload_instructions_1.1_description")
                    .replaceAll("*", '"')}
                </p>
              </div>

              <div className="pb-2">
                <p className="label-euro bold">
                  {params.t("po_management_upload_instructions_2")}
                </p>
                <p className="cardNameResumen">
                  {params
                    .t("po_management_upload_instructions_2_description")
                    .replaceAll("*", '"')}
                </p>
                <p className="cardNameResumen">
                  {params
                    .t("po_management_upload_instructions_2.1_description")
                    .replaceAll("*", '"')}
                </p>
              </div>

              <div className="pb-2">
                <p className="label-euro bold">
                  {params.t("po_management_upload_instructions_3")}
                </p>
                <p className="cardNameResumen">
                  {params
                    .t("po_management_upload_instructions_3_description")
                    .replaceAll("*", '"')}
                </p>
                <p className="cardNameResumen">
                  {params
                    .t("po_management_upload_instructions_3.1_description")
                    .replaceAll("*", '"')}
                </p>
                <p className="cardNameResumen">
                  {params
                    .t("po_management_upload_instructions_3.2_description")
                    .replaceAll("*", '"')}
                </p>
              </div>

              <div className="pb-2">
                <p className="label-euro bold">
                  {params.t("po_management_upload_instructions_4")}
                </p>
                <p className="cardNameResumen">
                  {params
                    .t("po_management_upload_instructions_4_description")
                    .replaceAll("*", '"')}
                </p>
                <p className="cardNameResumen">
                  {params
                    .t("po_management_upload_instructions_4.1_description")
                    .replaceAll("*", '"')}
                </p>
              </div>

              <div className="pb-2">
                <p className="label-euro bold">
                  {params.t("po_management_upload_instructions_5")}
                </p>
                <p className="cardNameResumen">
                  {params
                    .t("po_management_upload_instructions_5_description")
                    .replaceAll("*", '"')}
                </p>
              </div>

              <div className="pb-2">
                <p className="label-euro bold">
                  {params.t("po_management_upload_instructions_extra")}
                </p>
                <p className="cardNameResumen">
                  {params
                    .t("po_management_upload_instructions_extra_1")
                    .replaceAll("*", '"')}
                </p>
              </div>

              <div className="pb-2">
                <p className="label-euro bold">
                  {params.t("po_management_upload_instructions_note")}
                </p>
                <p className="cardNameResumen">
                  {params
                    .t("po_management_upload_instructions_note_1_description")
                    .replaceAll("*", '"')}
                </p>
                <p className="cardNameResumen">
                  {params
                    .t("po_management_upload_instructions_note_2_description")
                    .replaceAll("*", '"')}
                </p>
                <p className="cardNameResumen">
                  {params
                    .t("po_management_upload_instructions_note_3_description")
                    .replaceAll("*", '"')}
                </p>
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>


      {createModal({
        isModalOpen: modalAlert,
        titleModal: modalType !== 'error' ? 'Success' : 'Error',
        type: modalType,
        component: (
          <>
            <div className="col-12" style={{ textAlign: "center" }}>
              <p>{modalMessage}</p>
            </div>
          </>
        ),
        buttons: [
          {
            text: "Ok",
            onClick: () => setModalAlert(false),
            type: "primary",
          }
        ],
        onCancel: () => setModalAlert(false),
      })}
      {createModal({
        isModalOpen: uploadDocPo,
        titleModal: modalType !== 'error' ? 'Success' : 'Error',
        type: modalType,
        component: (
          <>
            <div className="col-12" style={{ textAlign: "center" }}>
              <p>{modalMessage}</p>
            </div>
          </>
        ),
        buttons: [
          {
            text: "Ok",
            onClick: () => params.history.push("/po-management"),
            type: "primary",
          }
        ],
        onCancel: () => params.history.push("/po-management"),
      })}
    </ContentWrapper>
  );
}
const mapStateToProps = (state) => ({
  clients: state.header.clients,
  lang: state.header.lang,
});
export default withNamespaces()(connect(mapStateToProps)(withRouter(LoadPO)));
